var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCycleHire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1957,
    height: 1962,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "visible",
    viewBox: "0 0 1957 1962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 260,
    width: 1954,
    height: 1955
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 260,
    width: 1954,
    height: 1955
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 260,
    width: 1954,
    height: 1955
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1333 -256)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M1708 1686.5 1708 1686.5C1708 1655.3 1733.3 1630 1764.5 1630L2114 1630 2114 1743 1764.5 1743C1733.3 1743 1708 1717.7 1708 1686.5Z",
    fill: "#484848",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M1482.79 1445.87 1674.86 1299.43 1863.97 1547.44C1903.77 1599.64 1893.72 1674.22 1841.52 1714.02L1838.48 1716.34C1786.28 1756.14 1711.7 1746.08 1671.9 1693.89L1482.79 1445.87Z",
    fill: "#484848",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M1680.99 1385.08 1852.9 1254 2048.53 1510.57C2084.73 1558.04 2075.59 1625.87 2028.11 1662.07L2028.11 1662.07C1980.64 1698.26 1912.82 1689.12 1876.62 1641.65L1680.99 1385.08Z",
    fill: "#484848",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "clippath0",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clippath1",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clippath2",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1261.31-1505.44C1216.56-1505.44 1178.24-1521.37 1146.37-1553.25 1114.5-1585.12 1098.56-1623.43 1098.56-1668.19 1098.56-1712.94 1114.5-1751.26 1146.37-1783.13 1178.24-1815 1216.56-1830.94 1261.31-1830.94 1306.07-1830.94 1344.38-1815 1376.25-1783.13 1408.13-1751.26 1424.06-1712.94 1424.06-1668.19 1424.06-1623.43 1408.13-1585.12 1376.25-1553.25 1344.38-1521.37 1306.07-1505.44 1261.31-1505.44ZM878.85-1098.56 1057.88-911.4 1057.88-406.875 895.125-406.875 895.125-813.75 634.725-1041.6C615.738-1057.88 602.853-1074.83 596.072-1092.46 589.291-1110.09 585.9-1131.11 585.9-1155.53 585.9-1179.94 589.629-1200.62 597.089-1217.57 604.549-1234.53 617.093-1251.82 634.725-1269.45L862.575-1497.3C880.207-1514.93 898.854-1527.48 918.52-1534.94 938.187-1542.4 960.225-1546.13 984.638-1546.13 1009.05-1546.13 1031.09-1542.4 1050.75-1534.94 1070.42-1527.48 1089.07-1514.93 1106.7-1497.3L1261.31-1342.69C1297.93-1306.07 1340.65-1276.57 1389.48-1254.19 1438.3-1231.81 1493.23-1220.63 1554.26-1220.63L1554.26-1057.88C1468.82-1057.88 1391.51-1073.13 1322.34-1103.65 1253.18-1134.16 1192.14-1175.87 1139.25-1228.76L1074.15-1293.86 878.85-1098.56ZM406.875-976.5C522.157-976.5 618.79-937.507 696.773-859.523 774.757-781.54 813.75-684.907 813.75-569.625 813.75-454.343 774.757-357.71 696.773-279.727 618.79-201.742 522.157-162.75 406.875-162.75 291.593-162.75 194.961-201.742 116.977-279.727 38.9923-357.71 0-454.343 0-569.625 0-684.907 38.9923-781.54 116.977-859.523 194.961-937.507 291.593-976.5 406.875-976.5ZM406.875-284.813C484.181-284.813 550.976-312.954 607.261-369.239 663.546-425.524 691.688-492.319 691.688-569.625 691.688-646.931 663.546-713.726 607.261-770.011 550.976-826.296 484.181-854.438 406.875-854.438 329.569-854.438 262.774-826.296 206.489-770.011 150.205-713.726 122.063-646.931 122.063-569.625 122.063-492.319 150.205-425.524 206.489-369.239 262.774-312.954 329.569-284.813 406.875-284.813ZM1546.13-976.5C1661.41-976.5 1758.04-937.507 1836.02-859.523 1914.01-781.54 1953-684.907 1953-569.625 1953-454.343 1914.01-357.71 1836.02-279.727 1758.04-201.742 1661.41-162.75 1546.13-162.75 1430.84-162.75 1334.21-201.742 1256.23-279.727 1178.24-357.71 1139.25-454.343 1139.25-569.625 1139.25-684.907 1178.24-781.54 1256.23-859.523 1334.21-937.507 1430.84-976.5 1546.13-976.5ZM1546.13-284.813C1623.43-284.813 1690.23-312.954 1746.51-369.239 1802.8-425.524 1830.94-492.319 1830.94-569.625 1830.94-646.931 1802.8-713.726 1746.51-770.011 1690.23-826.296 1623.43-854.438 1546.13-854.438 1468.82-854.438 1402.02-826.296 1345.74-770.011 1289.45-713.726 1261.31-646.931 1261.31-569.625 1261.31-492.319 1289.45-425.524 1345.74-369.239 1402.02-312.954 1468.82-284.813 1546.13-284.813Z",
    fill: "#484848",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.00051 0 0 1 1335 2214)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleHire);
export default __webpack_public_path__ + "static/media/cycle_hire.ba456879ad67ca9beedab7da372d436d.svg";
export { ForwardRef as ReactComponent };